import { Link } from "react-router-dom";
import { useT } from "../i18n/index.js";

export function NotFoundPage() {
  const t = useT();

  return (
    <div className="pad-safe-x grid min-h-[100dvh] place-items-center bg-ground px-6 text-center">
      <div className="flex flex-col items-center gap-3">
        <p className="font-mono text-[0.75rem] tracking-widest text-muted uppercase">404</p>
        <h1 className="font-display text-2xl">{t("layout.notFound")}</h1>
        <Link
          to="/lists"
          className="min-h-[var(--touch)] content-center text-accent underline underline-offset-4"
        >
          {t("layout.backToLists")}
        </Link>
      </div>
    </div>
  );
}
